import { createFileRoute } from '@tanstack/react-router';
import { UserDetailPage } from '@pages/users';

/** Benutzerdetail-Route (/users/:userId) */
export const Route = createFileRoute('/_authenticated/users/$userId')({
  component: UserDetailPage,
});
